import Swiper from 'swiper/core';
import { Navigation } from 'swiper/modules';

export function initSwipers() {
    // NEWS
    const swiperNews = new Swiper('.swiper.swiper--news', {
        modules: [Navigation],
        slidesPerView: 1,
        //loop: true,
        spaceBetween: 10,
        centeredSlides: true,
        navigation: {
            nextEl: '.swiper--news .swiper-button-next',
            prevEl: '.swiper--news .swiper-button-prev',
        },
        breakpoints: {
            767: {
                slidesPerView: 3,
                spaceBetween: 40,
                centeredSlides: false,
            }
        }
    });

    // SUCCESS
    const swiperSuccess = new Swiper('.swiper.swiper--success', {
        modules: [Navigation],
        slidesPerView: 1,
        spaceBetween: 10,
        //loop: true,
        centeredSlides: true,
        navigation: {
            nextEl: '.swiper--success .swiper-button-next',
            prevEl: '.swiper--success .swiper-button-prev',
        },
        breakpoints: {
            767: {
                slidesPerView: 2,
                spaceBetween: 40,
                centeredSlides: false
            }
        }
    });

    // EXPERTS
    const expertSlider = new Swiper(".expert-slider", {
        modules: [Navigation],
        slidesPerView: 'auto',
        spaceBetween: 10,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        observer: true,
        observeParents: true,
        loop: true,
        navigation: {
            nextEl: '.expert-slider .swiper-button-next',
            prevEl: '.expert-slider .swiper-button-prev',
        },
        breakpoints: {
            767: {
                spaceBetween: 0,
                centeredSlides: true,
            }
        },
        on: {
            init: function () {
                this.update();
            },
            slideChange: function () {
                const activeSlide = this.slides[this.activeIndex];
                const name = activeSlide.getAttribute("data-name");
                const position = activeSlide.getAttribute("data-position");

                const infoBox = document.querySelector(".expert-slide-info-fixed");
                if (infoBox) {
                    infoBox.querySelector("h3").textContent = name || "";
                    infoBox.querySelector("p").textContent = position || "";
                }
            }
        }
    });
}
